import { render, staticRenderFns } from "./MobiMain.vue?vue&type=template&id=7b936f6a"
import script from "./MobiMain.vue?vue&type=script&lang=js"
export * from "./MobiMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports